import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { onePostWithAuthorMapper } from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { ApiComponent, ApiPageCategoryNew } from 'data-source/types.wp'
import { DSResource, DSRootCategoryPage, LinkedLinkProps } from 'shared-definitions/types'
import { rootCategoryHerosMapper } from './rootCategoryHerosMapper'

interface CategoryNewCodecOpts<T extends DSResource, A extends ApiComponent>
  extends PLinkMapperOpts,
    MetaMapperOpts {
  componentItemMapper: (input: A) => T | T[]
  authorLinkBuilder: (slug: string) => LinkedLinkProps
  slug: string
  pagePath: string
}

export function codecGetCategoryNewPage<T extends ApiComponent, A extends DSResource>(
  input: ApiPageCategoryNew<T>,
  opts: CategoryNewCodecOpts<A, T>
): DSRootCategoryPage<A> {
  return {
    head: headPropsMapper(input.head),
    pagePath: opts.pagePath,
    ampPagePath: null,
    sections: null,
    meta: metaMapper({ ...input, content: {} }, [input.title], opts),
    resource: 'root-category-page',
    title: input.title,
    slug: opts.slug,
    topics: input.topics.length
      ? {
          title: 'By category',
          items: input.topics.map(i => ({
            label: i.name,
            image: imageMapper(i.image, opts),
            pLink: pLinkMapper(i.slug, opts),
          })),
        }
      : null,
    hero: rootCategoryHerosMapper(input.featured_posts.map(i => onePostWithAuthorMapper(i, opts))),
    latest: {
      title: 'Our latest',
      posts: {
        ...paginationMapper(input.content),
        items: input.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
      },
    },
    sidebarAds: input.sidebar_ad.flatMap(opts.componentItemMapper),
  }
}
